import { defineStore } from 'pinia';
import type { RouteRecordRaw } from 'vue-router';
import { UserRole } from '@/router/config/roles';
import { hasRoutePermission } from '@/router/config/permission-utils';

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    isRoutesReady: false as boolean,
    routes: [] as RouteRecordRaw[],
  }),
  actions: {
    generateRoutes(userRole: UserRole | null | undefined, asyncRoutes: RouteRecordRaw[]) {
      const filter = (routes: RouteRecordRaw[]): RouteRecordRaw[] =>
        routes
          .filter(r => hasRoutePermission(userRole, r))
          .map(r => {
            const route = { ...r };
            if (r.children) {
              route.children = filter(r.children);
            }
            return route;
          });

      this.routes = filter(asyncRoutes);
      return this.routes;
    },
    resetRoutes() {
      this.isRoutesReady = false;
      this.routes = [];
    }
  }
});
